import type { FaireProductEntity } from "../../entity_types/product";

export const p_vqpd9fxugp: FaireProductEntity = {
  token: "p_vqpd9fxugp",
  type: "product",
  name: "Frankincense & Sweet Myrrh Infused Therapeutic Rubbing Oil",
  brandToken: "b_3xnt44ssqi",
  brandName: "Balm of Gilead",
  imageUrl:
    "https://cdn.faire.com/fastly/24cca0d30ee476da8aed06e0fb439ad688c016b0b31ce0deecc89bb7aeaa8cc7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/05011d2ecd8014b43fbe463b2b27cfe2934563115048fc9fafb2cddae1202b69.jpeg",
  ],
  priceDollars: 11.99,
  description:
    "DIABETIC'S & AUTOIMMUNE DRY SKIN RELIEF\n\nSYNERGISTIC INFUSION – Frankincense + Sweet Myrrh therapeutic oil – our oils are completely WILD-HARVESTED to ensure maximum THERAPEUTIC potential - FIELD TO BOTTLE, entirely traceable ingredients.\nSKIN SUPERFOOD - abundant in vitamins A, C, D, E, and K, readily absorbed and non-greasy - DESIGNED TO NOURISH DIABETIC SKIN and those with heightened AUTOIMMUNE SKIN CONDITIONS | NUTRIENT-DENSE FOR INTENSIVE HEALING! Feet, Heels, Ankles, Elbows, Knees, Whole Body.\nDISTILLER-DIRECT ESSENTIAL OILS - an unprecedented infusion of RARE BLACK FRANKINCENSE OIL + SWEET MYRRH - most companies infuse traditional frankincense and myrrh, however after extensive research on multiple combinations of boswellia and commiphora species, aromatically and therapeutically, our combination stands alone - you won't be disappointed!\nRELIEVES + SOOTHES SKIN - naturally soothes and relieves dry, itchy skin - IDEAL FOR MEN, WOMEN, CHILDREN, AND THE ELDERLY - SAFE AND EFFECTIVE",
  tags: [],
  msrpDollars: 19.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:52.447Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
